import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import api from '../lib/api';
import { toast } from 'sonner';
import { EnvelopeSimple, ArrowLeft } from '@phosphor-icons/react';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setDone(true);
      toast.success('Instruksi pemulihan telah dikirim!');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Gagal mengirim email');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background text-foreground">
      <Navbar />
      <main className="max-w-md mx-auto px-4 py-16">
        <div className="border-2 border-foreground bg-white shadow-brutal-lg p-8">
          <Link to="/login" className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest hover:text-primary mb-6 transition-colors">
            <ArrowLeft weight="bold" /> Kembali ke Login
          </Link>
          
          <h1 className="font-display text-4xl font-bold tracking-tight mb-2">Lupa Kata Sandi?</h1>
          <p className="text-foreground/70 text-sm mb-6">
            Masukkan email Anda dan kami akan mengirimkan tautan untuk mengatur ulang kata sandi Anda.
          </p>

          {!done ? (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="text-xs uppercase tracking-widest font-bold block mb-2">Email Akun</label>
                <div className="relative">
                  <EnvelopeSimple size={18} weight="bold" className="absolute left-3 top-1/2 -translate-y-1/2" />
                  <input
                    type="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full border-2 border-foreground bg-white pl-10 pr-4 py-3 shadow-brutal-sm focus:outline-none focus:border-primary transition-all"
                    placeholder="kamu@email.com"
                  />
                </div>
              </div>
              <button
                type="submit"
                disabled={loading}
                className="w-full border-2 border-foreground bg-primary text-white px-4 py-3 font-bold uppercase tracking-wide shadow-brutal hover:shadow-brutal-sm hover:translate-x-[2px] hover:translate-y-[2px] active:shadow-none active:translate-x-[4px] active:translate-y-[4px] transition-all disabled:opacity-60"
              >
                {loading ? 'Mengirim...' : 'Kirim Instruksi'}
              </button>
            </form>
          ) : (
            <div className="border-2 border-foreground bg-secondary p-4 shadow-brutal-sm">
              <p className="text-sm font-bold">Email Berhasil Dikirim!</p>
              <p className="text-xs mt-1">Silakan cek kotak masuk email <strong>{email}</strong> Anda (termasuk folder spam) untuk mengatur ulang kata sandi.</p>
            </div>
          )}
        </div>
      </main>
    </div>
  );
}
